import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function AuditoriaAdmin() {
    return (
        <Card>
            <CardHeader><CardTitle>Auditoria</CardTitle></CardHeader>
            <CardContent>
                <div className="p-4 text-center text-stone-500">
                    Módulo em manutenção.
                </div>
            </CardContent>
        </Card>
    );
}
